import { ShipUpgrade, SheetPopulation } from '@prometheus/types'
import { createShipUpgradeLevels } from './createShipUpgradeLevels'

export function getShipMaxPopulation(ship_upgrades: ShipUpgrade[], population?: SheetPopulation) {
  if (!population) {
    return ship_upgrades[0].max
  }

  return createShipUpgradeLevels(ship_upgrades)[population.level].max
}
